import React from "react"
import { Route, Redirect } from "react-router-dom"
import { isEmpty } from "lodash"

export default ({ component: C, props: cProps, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      !isEmpty(cProps.authentication.authenticatedUser) ? (
        <C {...props} {...cProps} />
      ) : (
        <Redirect
          to={{
            pathname: `/login`,
            state: {
              redirect: `${props.location.pathname}${props.location.search}`,
            },
          }}
        />
      )
    }
  />
)
